export const BONUS_PROGRESS_POLLING_INTERVAL = 45;
export const BONUS_PROGRESS_LABEL_KEY = "game-launcher.bonus-progress";
